import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import HeaderContainer from "components/common/InfoPopup/HeaderContainer";
import PaymentStatusSummary from "components/common/InfoPopup/PaymentStatusSummary";
import { formatShortAddress } from "helpers/address";

InfoFreightHeader.propTypes = {
    data: PropTypes.shape({
        company_logo_url_small: PropTypes.shape({ data: PropTypes.any }),
        name: PropTypes.string,
        ratings: PropTypes.shape({ rate: PropTypes.number }),
        loading_address: PropTypes.object,
        unloading_address: PropTypes.object,
        bodytype: PropTypes.string,
        company_id: PropTypes.string,
        is_verified: PropTypes.bool,
    }),
    showChatButton: PropTypes.bool,
    onChatClick: PropTypes.func,
};

export default function InfoFreightHeader({ data, showChatButton, onChatClick }) {
    const { t } = useTranslation();

    return (
        <HeaderContainer
            companyLogo={data.company_logo_url_small && data.company_logo_url_small.data}
            companyName={data.name}
            companyId={data.company_id}
            isVerified={Boolean(data.is_verified || data.company?.is_verified)}
            ratings={data.ratings}
            showChatButton={showChatButton}
            onChatClick={onChatClick}
            items={[
                {
                    title: t("exchangeModal.uploading"),
                    value: formatShortAddress(data.loading_address),
                },
                {
                    title: t("exchangeModal.unloading"),
                    value: formatShortAddress(data.unloading_address),
                },
                {
                    title: t("exchangeModal.bodyType"),
                    value: data.bodytype,
                },
            ]}
            paymentStatusSummary={<PaymentStatusSummary companyId={data.company_id} />}
        />
    );
}
